export const NONE = "none";
export const SMALL = "small";
export const MED = "medium";
export const LRG = "large";

export const HALF = "half";
export const FULL = "full";

export const LEFT = "left";

export const LIGHT = "light";
